import { render, staticRenderFns } from "./Bankscheme.vue?vue&type=template&id=451e1b47&scoped=true"
import script from "./Bankscheme.vue?vue&type=script&lang=js"
export * from "./Bankscheme.vue?vue&type=script&lang=js"
import style0 from "./Bankscheme.vue?vue&type=style&index=0&id=451e1b47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e1b47",
  null
  
)

export default component.exports